import React, { useState, useEffect } from "react";
import axios from "axios";
import "../styles/intake.css";

export default function BookingSystemForm({ clinicId, formData, setFormData }) {
  const [isEditing, setIsEditing] = useState(true);

  const [appName, setAppName] = useState("");
  const [loginUrl, setLoginUrl] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const bookingOptions = [
    "Calendly",
    "JaneApp",
    "Square",
    "Vagaro",
    "Fresha",
    "Mindbody",
    "Other",
  ];

  const handleSave = async () => {
    
    if (!clinicId) {
      alert("Missing clinic ID");
      return;
    }

    const payload = {
      clinic_id: clinicId,
      booking_app: appName,
      login_url: loginUrl,
      username,
      password,
    };
    

    console.log("Saving booking info with payload:", payload);
    console.log("typeof clinicId:", typeof clinicId, "value:", clinicId);

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/booking/save-booking-info`, payload);
      setIsEditing(false);
      alert("Booking system info saved!");

      // Optional: store in formData for later submission
      setFormData((prev) => ({
        ...prev,
        booking_system: {
          booking_app: appName,
          login_url: loginUrl,
          username,
          password,
        },
      }));
    } catch (err) {
      console.error("Error saving booking info", err);
      alert("Failed to save booking info.");
    }
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  

  const handleChange = (setter) => (e) => setter(e.target.value);

  useEffect(() => {
    if (!clinicId) return;

    const fetchBookingInfo = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/booking/get-booking-info`,
          { params: { clinic_id: clinicId } }
        );

        if (res.data.status === "success" && res.data.data) {
          const data = res.data.data;
          setAppName(data.booking_app || "");
          setLoginUrl(data.login_url || "");
          setUsername(data.username || "");
          setPassword(data.password || "");

          setIsEditing(false);
        }
      } catch (err) {
        console.error("Error fetching booking info", err);
      }
    };

    fetchBookingInfo();
  }, [clinicId]);

  return (
    <div className="form-wrapper">
      {/* Header */}
      <div className="form-section-header">
        <h2>6. <span className="section-title">Booking System</span></h2>
        <div className="form-buttons">
          {isEditing ? (
            <button className="blue-button" onClick={handleSave}>Save</button>
          ) : (
            <button className="blue-button" onClick={handleEdit}>Edit</button>
          )}
        </div>
      </div>

      <div className="separator" />

      <div className="note">
        <p style={{ fontWeight: "bold", marginBottom: "30px", color: '#004aad', fontSize: '16px', marginTop: '-10px', width: '100%', textAlign: 'left' }}>
          Note: please create an account in your booking system and fill up the account information here for our AI to make appointments
        </p>
      </div>

      {/* Form Fields */}
      <div className="form-grid">
        {/* Booking App Name */}
        <div className="form-field">
          <div className="field-name">
            <label>Booking App Name</label>
          </div>
          <select
            name="booking_app"
            value={appName}
            onChange={handleChange(setAppName)}
            className="app-select"
            disabled={!isEditing}
          >
            <option value="">-- Select Booking App --</option>
            {bookingOptions.map((option) => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </div>

        {/* Login Page */}
        <div className="form-field full-width2">
          <label>Booking App Login Page</label>
          <input
            type="url"
            name="login_url"
            placeholder="https://yourbookingapp.com/login"
            value={loginUrl}
            onChange={handleChange(setLoginUrl)}
            disabled={!isEditing}
          />
        </div>

        {/* Username */}
        <div className="form-field">
          <label>Username <span className="required">*</span></label>
          <input
            type="text"
            name="username"
            value={username}
            onChange={handleChange(setUsername)}
            disabled={!isEditing}
          />
        </div>

        {/* Password */}
        <div className="form-field" style={{ position: "relative"}}>
          <label>Password <span className="required">*</span></label>
          <div className="password-field-with-toggle" style={{ position: "relative" }}>
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            value={password}
            onChange={handleChange(setPassword)}
            disabled={!isEditing}
            style={{ paddingRight: "20px" }}
          />
          <span
            onClick={togglePasswordVisibility}
            style={{
              position: "relative",
              right: "30px",
              top: "0px",
              cursor: "pointer",
              fontSize: "18px",
              color: "#888"
            }}
          >
            {showPassword ? "🙈" : "👀"}
          </span>
        </div>

        
        </div>
      </div>
    </div>
  );
}

